/**
 * O azul da Vera, no mesmo molde dos tokens do Lucas.
 *
 * ## Por que dois azuis, e não um
 *
 * Mesma razão medida que lá: um tom só teria que escolher entre sumir no tema
 * claro ou no escuro. `#38bdf8` sobre a superfície escura dá 8.57 de
 * contraste, e sobre branco daria 1.9, que é invisível. Então o tom fecha no
 * claro (`#0369a1`, 5.93 sobre branco) e abre no escuro. É o mesmo matiz: lê
 * como a mesma cor, só não desaparece.
 *
 * ## Por que a classe inteira, e não o hex
 *
 * O Tailwind varre o código à procura das classes literais para gerar o CSS.
 * Um `text-[${COR}]` montado em tempo de execução não seria encontrado nem
 * gerado, e a cor simplesmente não sairia.
 *
 * ## Por que a superfície é a mesma do Lucas
 *
 * Os dois atalhos moram no mesmo canto, um em cima do outro. Superfícies
 * diferentes fariam parecer que são de produtos diferentes; o que precisa
 * distinguir um do outro é a COR do ícone, não o chip inteiro.
 */

/** Cor do ícone, nos dois temas. */
export const VERA_ACCENT_TEXT = "text-[#0369a1] dark:text-[#38bdf8]";

/** Preenchimento, para quando a cor precisar ser fundo e não traço. */
export const VERA_ACCENT_BG = "bg-[#0369a1] dark:bg-[#38bdf8]";

/** Os hex puros, para medições e para quem precisar do valor e não da classe. */
export const VERA_ACCENT_DARK = "#38bdf8";
export const VERA_ACCENT_LIGHT = "#0369a1";
